export default __webpack_public_path__ + "static/media/Plus.f9e04b19.svg";